module.exports = __webpack_public_path__ + "img/Color-Alternate.eff1611c.png";